import styles from './styles.module.scss';


export default function Card({membro,deletarMembro}) {
    return (
        <div className={styles.card}>
            <p>{membro.nome}</p>
            <p>{membro.cargo}</p>
            <img src={membro.imagem} alt={membro.nome + " " + membro.cargo} />
            <button onClick={() => deletarMembro(membro.id)} className={styles.delete}>Deletar</button>

        </div>

    )

}